import type { FlowSlotDto } from '@/types/dtos/flows/response/flow.dto';
import { getSlotAssetsDetailsTitle } from '../edit-details/slot-assets-details-title';
import { FlowControlSlotMediaBelowRow } from './flow-control-slot-media-below-row';
import { useFlowControlSegmentActive } from './use-flow-control-segment-active';
import type { FlowControlSegmentKind } from '@/helpers/simulation-cue-engine.helper';
import { resolveFlowControlSlotMediaActiveId } from '@/helpers/flow-control-playing-segment.helper';

function segmentKindForSlot(slot: FlowSlotDto): FlowControlSegmentKind {
  return slot.contentType === 'Break' ? 'break' : 'session';
}

/** Inline break/session playlist under a control-tab slot row (manual expand or auto-follow while playing). */
export function FlowControlInlineSlotMediaPanel({
  slot,
  expandId,
  playingExpandId,
}: {
  slot: FlowSlotDto;
  expandId: string | null;
  playingExpandId: string | null;
}) {
  const segmentKind = segmentKindForSlot(slot);
  const isSegmentPlaying = useFlowControlSegmentActive('slot', segmentKind, slot.id);
  const activeSlotId = resolveFlowControlSlotMediaActiveId(slot.id, expandId, playingExpandId, isSegmentPlaying);
  const show = activeSlotId != null;

  return (
    <FlowControlSlotMediaBelowRow
      slot={slot}
      activeSlotId={activeSlotId}
      show={show}
      slotTitle={getSlotAssetsDetailsTitle(slot)}
    />
  );
}
